import { c as _c } from "react/compiler-runtime";
import { usePageLayout } from '../../hooks/usePageLayout';
import { useUserSession } from '../../hooks/useUserSession';
export const useCustomerKey = () => {
  const $ = _c(2);
  const {
    userData: userDataPageLayout
  } = usePageLayout();
  const {
    userData: userDataSession
  } = useUserSession();
  const customerKeyUserPageLayout = userDataPageLayout?.profile?.customerKey;
  const customerKeyUserSession = userDataSession?.profile?.customerKey;
  const customerKey = customerKeyUserPageLayout || customerKeyUserSession;
  const t0 = customerKey ? String(customerKey) : undefined;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      customerKey: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};